import createApiClient from '../createApiClient'
import ENDPOINTS from './endpoints'

const apiClient = createApiClient()

const cloneFormData = (formData) => {
  const next = new FormData()
  for (const [key, value] of formData.entries()) {
    next.append(key, value)
  }
  return next
}

const tryCandidatePost = async (candidates = [], formData) => {
  let lastError = null
  for (const path of candidates) {
    try {
      return await apiClient.post(path, cloneFormData(formData))
    } catch (error) {
      lastError = error
      const status = error?.response?.status
      if (status && status !== 404) {
        throw error
      }
    }
  }
  throw lastError || new Error('No matching API endpoint available')
}

const userApi = {
  getVendorPackages(formData) {
    return apiClient.post(ENDPOINTS.VENDOR_PACKAGES, formData)
  },

  getVenuesInvite(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUES_INVITE, formData)
  },

  getVenueDetailInvite(formData) {
    return apiClient.post(ENDPOINTS.GET_VENUE_DETAIL_INVITE, formData)
  },

  socialLogin(formData) {
    return tryCandidatePost(ENDPOINTS.SOCIAL_LOGIN_CANDIDATES, formData)
  },

  requestPasswordReset(formData) {
    return tryCandidatePost(ENDPOINTS.FORGOT_PASSWORD_CANDIDATES, formData)
  },

  verifyPasswordReset(formData) {
    return tryCandidatePost(ENDPOINTS.FORGOT_PASSWORD_VERIFY_CANDIDATES, formData)
  },


  // ------------
  loginApi(formData) { 
    return apiClient.post(ENDPOINTS.LOGIN, formData)
  },

  // ------------
  socialLoginApi(formData) { 
    return apiClient.post(ENDPOINTS.SOCIAL_LOGIN, formData)
  },

  // ------------
  registerApi(formData) { 
    return apiClient.post(ENDPOINTS.REGISTER, formData)
  },

  // ------------
  getProfileApi(formData) { 
    return apiClient.post(ENDPOINTS.GET_PROFILE, formData)
  },

  changePassword(formData){
     return apiClient.post(ENDPOINTS.CHANGE_PASSWORD, formData)
  },

  moreApps(formData){
     return apiClient.post(ENDPOINTS.MORE_APPS, formData)
  },

  // ------------
  updateProfile(formData) { 
    return apiClient.post(ENDPOINTS.UPDATE_PROFILE, formData)
  },

  deleteAccount(formData) {
    return tryCandidatePost(ENDPOINTS.DELETE_ACCOUNT_CANDIDATES, formData)
  },

  // ------------
  loginResetApi(formData) { 
    return apiClient.post(ENDPOINTS.LOGIN_RESET, formData)
  },

  // ------------
  loginResetVerifyApi(formData) { 
    return apiClient.post(ENDPOINTS.LOGIN_RESET_VERIFY, formData)
  },

  // ------------
  getInvitations(formData) { 
    return apiClient.post(ENDPOINTS.GET_INVITATIONS, formData)
  },

  getConnections(formData){
     return apiClient.post(ENDPOINTS.GET_CONNECTIONS, formData)
  },

  getConnectionsStats(formData){
     return apiClient.post(ENDPOINTS.GET_CONNECTIONS_STATS, formData)
  },

  getConnectionsEvents(formData){
     return apiClient.post(ENDPOINTS.GET_CONNECTIONS_EVENTS, formData)
  },

  getEventTypes(){
    return apiClient.get(ENDPOINTS.GET_EVENT_TYPES)
  },

  getInvitationDetail(formData) {
    return apiClient.post(ENDPOINTS.GET_INVITATION_DETAIL, formData)
  },

  getReceivedInvitationDetail(formData) {
    return apiClient.post(ENDPOINTS.GET_RECEIVED_INVITATION_DETAIL, formData)
  },

  getNotesMembersEventDetail(formData) {
    return apiClient.post(ENDPOINTS.GET_NOTES_MEMBERS_EVENT_DETAIL, formData)
  },

  getReceivedInvitationsProfile(formData) {
    return apiClient.post(ENDPOINTS.GET_RECEIVED_INVITATIONS_PROFILE, formData)
  },

  saveFeedback(formData){
    return apiClient.post(ENDPOINTS.SAVE_FEEDBACK, formData)
  },

  updateFeedback(formData){
    return apiClient.post(ENDPOINTS.UPDATE_FEEDBACK, formData)
  },

  feedbackList(formData){
    return apiClient.post(ENDPOINTS.FEEDBACK_LIST, formData)
  },


  getGuestsList(formData) {
    return apiClient.post(ENDPOINTS.GET_GUESTS_LIST, formData)
  },

  addGuest(formData) {
    return apiClient.post(ENDPOINTS.ADD_GUEST, formData)
  },

  addGuestAuto(formData){
    return apiClient.post(ENDPOINTS.ADD_GUEST_AUTO, formData)
  },

  addGuestNew(formData) {
    return apiClient.post(ENDPOINTS.CREATE_CONTACT_NEW, formData)
  },

  editGuest(formData) {
    return apiClient.post(ENDPOINTS.EDIT_GUEST, formData)
  },

  deleteGuest(formData) {
    return apiClient.post(ENDPOINTS.DELETE_GUEST, formData)
  },

  deleteGuestList(formData) {
    return apiClient.post(ENDPOINTS.DELETE_GUEST_INVITATION, formData)
  },

  getCoHostsList(formData) {
    return apiClient.post(ENDPOINTS.GET_COHOSTS, formData)
  },

  updateCohost(formData){
     return apiClient.post(ENDPOINTS.UPDATE_COHOSTS,formData)
  },

  sendInvite(formData){
     return apiClient.post(ENDPOINTS.SEND_INVITE,formData)
  },
  
  resendInvite(formData){
     return apiClient.post(ENDPOINTS.RESEND_INVITE_MEMBER,formData)
  },

  sendInvitePhone(formData){
     return apiClient.post(ENDPOINTS.SEND_INVITE_PHONE,formData)
  },
  
  resendInvitePhone(formData){
     return apiClient.post(ENDPOINTS.RESEND_INVITE_MEMBER_PHONE,formData)
  },




  getHiredVendors(formData){
     return apiClient.post(ENDPOINTS.INVITE_HIRED_VENDORS,formData)
  },

  addHiredVendors(formData){
     return apiClient.post(ENDPOINTS.SEND_INVITE_VENDORS,formData)
  },

  updateHiredVendors(formData){
     return apiClient.post(ENDPOINTS.UPDATE_INVITE_VENDOR_CATEGORIES,formData)
  },

  deleteHiredVendors(formData){
     return apiClient.post(ENDPOINTS.DELETE_HIRED_VENDORS,formData)
  },

  getNearByVendors(formData){
     return apiClient.post(ENDPOINTS.NEARBY_VENDORS,formData)
  },


  getReceivedInvitations(formData){
      return apiClient.post(ENDPOINTS.GET_RECEIVED_INVITATIONS, formData)
  },

  getAlbums(formData){
      return apiClient.post(ENDPOINTS.GET_ALBUMS, formData)
  },

  getReceivedAlbums(formData){
      return apiClient.post(ENDPOINTS.GET_RECEIVED_ALBUMS, formData)
  },
  
  checkISHost(formData){
      return apiClient.post(ENDPOINTS.CHECK_HOST, formData)
  },

  getAlbumPublic(formData){
      return apiClient.post(ENDPOINTS.GET_ALBUM_PUBLIC, formData)
  },

  getAlbumPrivate(formData){
      return apiClient.post(ENDPOINTS.GET_ALBUM_PRIVATE, formData)
  },

  getAlbumDetail(formData){
      return apiClient.post(ENDPOINTS.GET_EVENT_DETAIL, formData)
  },

  AlbumUploadImages(formData){
     return apiClient.post(ENDPOINTS.UPLOAD_ALBUM, formData)
  },

  deleteAlbumImages(formData){
     return apiClient.post(ENDPOINTS.DELETE_ALBUM_IMAGE, formData)
  },

  CreateInvitation(formData){
     return apiClient.post(ENDPOINTS.CREATE_INVITATION, formData)
  },

  editInvitation(formData){
     return apiClient.post(ENDPOINTS.UPDATE_INVITATION, formData)
  },

  deleteInvitation(formData){
     return apiClient.post(ENDPOINTS.DELETE_INVITATION, formData)
  },

  getPosterCategories(){
    return apiClient.get(ENDPOINTS.GET_POSTER_CATEGORIES)
  },

  getPosters(formData){
     return apiClient.post(ENDPOINTS.GET_POSTERS, formData)
  },

  // utils/api.js
  getGifs(queryParams) {
    const queryString = new URLSearchParams(queryParams).toString();
    return apiClient.get(`${ENDPOINTS.GET_GIFS}?${queryString}`);
  },

  getGiphy(queryParams){
    const queryString = new URLSearchParams(queryParams).toString();
    return apiClient.get(`${ENDPOINTS.GET_GIFHY}?${queryString}`);
  },

  saveShareGuests(formData){
     return apiClient.post(ENDPOINTS.SAVE_SHARE_GUESTS, formData)
  },

  updatePermissions(formData){
     return apiClient.post(ENDPOINTS.UPDATE_ALBUM_SETTINGS, formData)
  },

  getCategoriesList(formData){
    return apiClient.post(ENDPOINTS.GET_CATEGORIES_LIST, formData)
  },

  saveViewPermissions(formData){
    return apiClient.post(ENDPOINTS.UPLOAD_PERMISSIONS, formData)
  },

  getVendors(formData){
     return apiClient.post(ENDPOINTS.GET_VENDORS, formData)
  },


  getMyContacts(formData){
      return apiClient.post(ENDPOINTS.CONTACTS_LIST, formData)
  },

  getMyFriends(formData){
      return apiClient.post(ENDPOINTS.FRIENDS_LIST, formData)
  },


  searchUsersInfo(formData){
      return apiClient.post(ENDPOINTS.SEARCH_USER_INFO, formData)
  },


  sendRequestContact(formData){
      return apiClient.post(ENDPOINTS.SEND_REQUEST, formData)
  },


  approveRequest(formData){
      return apiClient.post(ENDPOINTS.APPROVE_REQUEST, formData)
  },

  cancelRequest(formData){
      return apiClient.post(ENDPOINTS.CANCEL_REQUEST, formData)
  },

  saveAlbumAcess(formData){
     return apiClient.post(ENDPOINTS.SAVE_SHARE_GUESTS, formData)
  },
  
  removeAlbumFriend(formData){
     return apiClient.post(ENDPOINTS.REMOVE_ACCESS, formData)
  },

  getEnquiries(formData){
     return apiClient.post(ENDPOINTS.ENQUIRIES_LIST, formData)
  },

  getInviteEnquiryDetails(formData){
     return apiClient.post(ENDPOINTS.ENQUIRY_DETAIL, formData)
  },

  sendEnquiry(formData){
     return apiClient.post(ENDPOINTS.SEND_ENQUIRY, formData)
  },

  sendVenueEnquiry(formData){
     return apiClient.post(ENDPOINTS.SEND_VENUE_ENQUIRY, formData)
  },

  getBusinessDetail(formData){
     return apiClient.post(ENDPOINTS.VENDOR_DETAIL, formData)
  },

  getVendorProducts(formData){
     return apiClient.post(ENDPOINTS.VENDOR_PRODUCTS, formData)
  },

  getEnquiryCategories(formData){
     return apiClient.post(ENDPOINTS.ENQUIRY_CATEGORIES_LIST, formData)
  },

  updateRSVP(formData){
     return apiClient.post(ENDPOINTS.UPDATE_RSVP, formData)
  },



  updateRSVPGuest(formData){
     return apiClient.post(ENDPOINTS.UPDATE_RSVP_GUEST, formData)
  },

  updateRSVPLogin(formData){
     return apiClient.post(ENDPOINTS.UPDATE_RSVP_LOGIN, formData)
  },

  getWebCount(formData){
     return apiClient.post(ENDPOINTS.GET_WEB_COUNT, formData)
  },

  checkExistingInvitation(formData){
     return apiClient.post(ENDPOINTS.CHECK_EXIST_INVITATION, formData)
  },

  updateRSVPReceived(formData){
     return apiClient.post(ENDPOINTS.UPDATE_RECEIVED_RSVP, formData)
  },

  getScannedGuests(formData){
    return apiClient.post(ENDPOINTS.SCANNED, formData)
  },

  updateEventSettings(formData){
    return apiClient.post(ENDPOINTS.UPDATE_EVENT_SETTINGS, formData)
  },

  getInviteModules(formData){
    return apiClient.post(ENDPOINTS.GET_INVITE_MODULES, formData)
  },

  getEventPosts(formData){
    return apiClient.post(ENDPOINTS.GET_EVENT_POSTS, formData)
  },

  addEventPost(formData){
    return apiClient.post(ENDPOINTS.ADD_EVENT_POST, formData)
  },

  deleteEventPost(formData){
    return apiClient.post(ENDPOINTS.DELETE_EVENT_POST, formData)
  },

  likeEventPost(formData){
    return apiClient.post(ENDPOINTS.LIKE_EVENT_POST, formData)
  },

  updatePollEventPost(formData){
    return apiClient.post(ENDPOINTS.UPDATE_POLL_EVENT_POST, formData)
  },

  getEventPostVotes(formData){
    return apiClient.post(ENDPOINTS.GET_VOTES_EVENT_POST, formData)
  },

  getEventPostComments(formData){
    return apiClient.post(ENDPOINTS.VIEW_EVENT_POST_COMMENTS, formData)
  },

  addEventPostComment(formData){
    return apiClient.post(ENDPOINTS.ADD_EVENT_POST_COMMENT, formData)
  }

}

userApi.login = userApi.loginApi
userApi.register = userApi.registerApi
userApi.getProfile = userApi.getProfileApi
userApi.getVendorDetail = userApi.getBusinessDetail

export default userApi
